/**
 * Riordina un array spostando l'elemento da startIndex a endIndex.
 */
export function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}

/**
 * Costruisce mappature dalle proprieta dell'API:
 * - childrenOf: parentCode -> [childCode, ...] per gestire la deselezione
 * - depthOf: code -> profondita nell'albero (0 = root) per ordinare padri prima dei figli
 */
export function buildPropertyMappings(properties) {
    const idToCode = {};
    const idToParentId = {};
    const idToProperty = {};
    properties.forEach(p => {
        idToCode[p.id] = p.code;
        idToParentId[p.id] = p.parent_id;
        idToProperty[p.id] = p;
    });

    const childrenOf = {};
    const childrenIdsOf = {};
    properties.forEach(p => {
        if (p.parent_id !== null) {
            const parentCode = idToCode[p.parent_id];
            if (parentCode) {
                if (!childrenOf[parentCode]) childrenOf[parentCode] = [];
                childrenOf[parentCode].push(p.code);
            }
            if (!childrenIdsOf[p.parent_id]) childrenIdsOf[p.parent_id] = [];
            childrenIdsOf[p.parent_id].push(p);
        }
    });

    const depthOf = {};
    properties.forEach(p => {
        let depth = 0;
        let pid = p.parent_id;
        while (pid !== null && pid !== undefined) {
            depth++;
            pid = idToParentId[pid] || null;
        }
        depthOf[p.code] = depth;
    });

    // Indice DFS (Depth-First Search): percorre l'albero in profondità
    // (radice → primo figlio → foglia → fratello successivo) assegnando
    // un indice incrementale ad ogni nodo, così da poter ordinare le
    // proprietà selezionate nello stesso ordine in cui appaiono nell'albero.
    const treeIndexOf = {};
    let index = 0;
    function walk(parentId) {
        const children = (childrenIdsOf[parentId] || [])
            .sort((a, b) => (a.position || 0) - (b.position || 0));
        children.forEach(p => {
            treeIndexOf[p.code] = index++;
            walk(p.id);
        });
    }
    // Parti dai root (parent_id === null)
    properties
        .filter(p => p.parent_id === null)
        .sort((a, b) => (a.position || 0) - (b.position || 0))
        .forEach(p => {
            treeIndexOf[p.code] = index++;
            walk(p.id);
        });

    return { childrenOf, depthOf, treeIndexOf };
}

/**
 * Ordina i codici per profondita nell'albero (padri prima dei figli).
 * A parita di profondita mantiene l'ordine relativo.
 */
export function sortByDepth(codes, depthOf) {
    return [...codes].sort((a, b) => (depthOf[a] || 0) - (depthOf[b] || 0));
}

/**
 * Ordina i codici nell'ordine in cui appaiono nell'albero (DFS per position).
 */
export function sortByTreeOrder(codes, treeIndexOf) {
    return [...codes].sort((a, b) => (treeIndexOf[a] ?? Infinity) - (treeIndexOf[b] ?? Infinity));
}
